

export const articleSURL = import.meta.env.VITE_articles_url

